



















import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import { AlertObject } from '.';

export default mixins().extend({
  provide(): {
    alert_providershow: (key: string, alert: any) => void;
    alert_providerhide: (key: string) => any;
  } {
    return {
      alert_providershow: this.show,
      alert_providerhide: this.hide,
    };
  },

  computed: {
    alerts(): { key: string; alert: AlertObject }[] {
      return Array.from(this.internalAlerts.entries()).map((entry) => ({
        key: entry[0],
        alert: entry[1],
      }));
    },
  },

  data(): {
    internalAlerts: Map<string, AlertObject>;
  } {
    return {
      internalAlerts: new Map<string, AlertObject>(),
    };
  },

  methods: {
    show(key: string, alert: AlertObject) {
      alert.messages = alert.messages?.filter((message) => !!message);
      if (alert.messages?.length > 0) {
        this.internalAlerts = new Map(this.internalAlerts.set(key, alert));
      }
    },

    hide(key: string) {
      // TODO: there will be an issue with using .includes() as it doesn't do exact matching
      // 'save' will also match 'saveThing' which may cause issues
      // includes is needed so that it can clear all keys relating to a uuid  when no key is passed currently

      // find any matching alerts
      const keys = Array.from(this.internalAlerts.keys()).filter((internal) =>
        internal.includes(key)
      );

      if (keys.length > 0) {
        for (key in keys) {
          this.internalAlerts.delete(keys[key]);
        }
        this.internalAlerts = new Map(this.internalAlerts);
      }
    },

    handleRemoveAlert(alert: AlertObject) {
      // reverse lookup by value
      const result = Array.from(this.internalAlerts.entries()).find(
        (internal) => internal[1] === alert
      );
      if (result) {
        this.hide(result[0]);
      }
    },
  },
});
